import React from 'react';

import { getMetaContent } from '../../../lib/dom';

const useMapboxTileUrl = () => React.useMemo(() => getMetaContent('mapboxTileURL'), []);

export default useMapboxTileUrl;
